import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CxTableService } from '../../services/cx-table.service';
import { DialogService } from '../../../dynamicdialog';

@Component({
    selector: 'cx-edit-column-modal',
    templateUrl: 'edit-column-modal.component.html',
})
export class EditModalComponent {
    @Output() close = new EventEmitter();
    visible = true;
    constructor (public tableService: CxTableService) {
        this.tableService.editColumnRef?.close();
        // console.log(this.tableService.editColumnRef);
    }
    
}
